import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-ateb-dyddiol',
    templateUrl: './ateb-dyddiol.component.html',
    imports: [FormlyModule, MatButton]
})
export class AtebDyddiolComponent extends FieldArrayType {
  // TODO: add explicit constructor
 }
